import { LocationType } from 'api-client'
import { createSelector } from 'reselect'

import { SalesGroup } from '~shared-components/api/sales-groups'
import { SharedState } from '~shared-components/redux/sharedState'
import { CustomerContext } from '~shared-components/transforms/user.transforms'

export const selectLoginState = (state: SharedState) => state?.login

const selectedCustomerContext = createSelector(
  [selectLoginState],
  (state): CustomerContext | undefined => state.selectedCustomerContext,
)

const selectedCustomerContextId = createSelector(
  [selectedCustomerContext],
  state => state?.id,
)

const locations = createSelector(
  [selectedCustomerContext],
  state => state?.locations,
)

const shipToLocations = createSelector(
  [locations],
  locations => locations?.filter(l => l.type === LocationType.ShipTo) || [],
)

const selectedLocationId = createSelector(
  [selectLoginState],
  state => state.selectedLocationId,
)

const selectedSalesGroup = createSelector(
  [selectLoginState],
  (state): SalesGroup | undefined => state.selectedSalesGroup,
)

const selectedSalesOrganization = createSelector(
  [selectedSalesGroup],
  (state): string | undefined => state?.salesOrganization,
)

const selectedSalesGroupId = createSelector(
  [selectedSalesGroup],
  (state): string | undefined => state?.id,
)

const selectedLocation = createSelector(
  [selectedCustomerContext, selectedLocationId],
  (state, locationId) => state?.locations.find(l => l.id === locationId),
)

export const LoginSelector = {
  locations,
  selectedCustomerContext,
  selectedCustomerContextId,
  selectedLocation,
  selectedLocationId,
  selectedSalesGroup,
  selectedSalesGroupId,
  selectedSalesOrganization,
  shipToLocations,
}
